export default "__VITE_ASSET__B6SwPr6L__"